import { countriesEnum } from '../../../utils/constants/checkout';

export interface Choices{
  shippingRestrictions: string[] | null
}

export const checkShippingRestrictions = (choices:any[], country:string) => {
  if (choices) {
    const restrictions = choices.map((choice:Choices) => choice.shippingRestrictions).flat(1);
    return restrictions.includes(countriesEnum[country as keyof typeof countriesEnum]);
  }
  return false;
};
